import { render } from "./FooterRwd.vue?vue&type=template&id=7a61394d"
import script from "./FooterRwd.vue?vue&type=script&lang=js"
export * from "./FooterRwd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__